import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAddToPlaylistOptionList } from '../savedItemsHooks';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';

// all search code to be reenabled when API is available
// const SearchForm = styled(UIFormControl)`
//   width: 100%;
//   padding: 10px;
//   background-color: ${theme.colors.GYPSUM};
// `;
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PLAYLIST_HEIGHT = 250;
const LAZY_LOAD_DISTANCE = 40;
const useLazyLoadedPlaylists = (page, playlists, playlistsLoading) => {
  const [loadedPages, setLoadedPages] = useState([]);
  useEffect(() => {
    if (!playlists || playlistsLoading || loadedPages[page - 1]) return;
    // accumulate previously loaded playlists
    setLoadedPages([...loadedPages, playlists]);
  }, [loadedPages, page, playlists, playlistsLoading]);
  const displayedPlaylists = useMemo(() => {
    if (!loadedPages.length) return null;
    const allLoadedPlaylists = loadedPages.flatMap(p => p.flat());
    return allLoadedPlaylists;
  }, [loadedPages]);
  return {
    displayedPlaylists
  };
};

// const PlaylistSearchInput = ({
//   onSearchChange,
// }: {
//   onSearchChange: (text: string) => void;
// }) => {
//   const searchPlaceholder = I18n.text(
//     'academyCommon.cardMenu.searchPlaceholder'
//   );

//   return (
//     <SearchForm aria-label={searchPlaceholder}>
//       <UISearchInput
//         onChange={e => onSearchChange((e.target as any).value)}
//         placeholder={searchPlaceholder}
//         use="on-dark"
//       />
//     </SearchForm>
//   );
// };
export const PlaylistSearchResults = ({
  totalPlaylists,
  page,
  playlists,
  playlistsLoading,
  loadNextPage,
  loadMode,
  render,
  loadMoreButton = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.cardMenu.loadMorePlaylists"
  })
}) => {
  const {
    displayedPlaylists
  } = useLazyLoadedPlaylists(page, playlists, playlistsLoading);
  const handleScroll = useCallback(e => {
    const {
      scrollTop,
      scrollHeight
    } = e.target;
    if (!playlistsLoading && displayedPlaylists && displayedPlaylists.length < totalPlaylists && scrollTop + PLAYLIST_HEIGHT + LAZY_LOAD_DISTANCE >= scrollHeight) loadNextPage();
  }, [loadNextPage, displayedPlaylists, playlistsLoading, totalPlaylists]);
  const hasMore = displayedPlaylists && displayedPlaylists.length < totalPlaylists;
  return loadMode === 'lazy-load' ? /*#__PURE__*/_jsx(ScrollContainer, {
    gradientColor: "fill-surface-default",
    maxHeight: PLAYLIST_HEIGHT,
    onScroll: handleScroll,
    children: render(displayedPlaylists)
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [render(displayedPlaylists), hasMore && /*#__PURE__*/_jsx(Button, {
      onClick: loadNextPage,
      use: "unstyled",
      children: loadMoreButton
    })]
  });
};
const MyPlaylistsSearch = ({
  render,
  loadMode,
  loadMoreButton
}) => {
  const [page, setPage] = useState(1);
  // const [searchText, setSearchText] = useState('');

  const {
    totalPlaylists,
    playlists,
    playlistsLoading
  } = useAddToPlaylistOptionList({
    page
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(PlaylistSearchResults, {
      loadMode: loadMode,
      loadMoreButton: loadMoreButton,
      loadNextPage: () => setPage(page + 1),
      page: page,
      playlists: playlists,
      playlistsLoading: playlistsLoading,
      render: render,
      totalPlaylists: totalPlaylists
    })
  });
};
export default MyPlaylistsSearch;